import { ExternalIntegrationEnum } from 'api/clients/ExternalIntegrationsClient'
import useResponsiveDesign from './useResponsiveDesign'
import { useRootStore } from 'stores/RootStore'
import { ConnectAccountDrawer } from 'components/PostStatusDropdown/ConnectAccountDrawer'
import { channelTypeFromProvider } from 'components/ArticlePostPreview/ArticlePostPreviewContext'
import { SocialChannelType } from 'common/ShareSheetV2/Screens/Default/Default'
import { useModals } from 'almanac-ui/Modal'
import { useInitiateOauth } from './useInitiateOauth'
import XInitialization from 'components/IntegrationInitialization/XInitialization/XInitialization'
import {
  FacebookInitialization,
  InstagramInitialization,
  LinkedinInitialization,
  YouTubeInitialization,
  MailchimpInitialization,
  GoogleInitialization,
} from 'components/IntegrationInitialization'
import WordPressInitialization from 'components/IntegrationInitialization/WordPressInitialization/WordPressInitialization'

export const useConnectAccount = () => {
  const { isMobile } = useResponsiveDesign()
  const { drawersStore } = useRootStore()
  const { openModal } = useModals()
  const { initiateOauth } = useInitiateOauth()

  const handleConnectAccount = (provider: ExternalIntegrationEnum) => {
    switch (provider) {
      case ExternalIntegrationEnum.LinkedIn:
        openModal(LinkedinInitialization)
        break
      case ExternalIntegrationEnum.X:
        openModal(XInitialization)
        break
      case ExternalIntegrationEnum.Facebook:
        openModal(FacebookInitialization)
        break
      case ExternalIntegrationEnum.Instagram:
        openModal(InstagramInitialization)
        break
      case ExternalIntegrationEnum.YouTube:
        openModal(YouTubeInitialization)
        break
      case ExternalIntegrationEnum.TikTok:
        initiateOauth(ExternalIntegrationEnum.TikTok)
        break
      case ExternalIntegrationEnum.WordPress:
        openModal(WordPressInitialization)
        break
      case ExternalIntegrationEnum.GoHighLevel:
        initiateOauth(ExternalIntegrationEnum.GoHighLevel)
        break
      case ExternalIntegrationEnum.Mailchimp:
        openModal(MailchimpInitialization)
        break
      case ExternalIntegrationEnum.Google:
        openModal(GoogleInitialization)
        break
      default:
        break
    }
  }

  const connectAccount = (provider: ExternalIntegrationEnum) => {
    if (isMobile) {
      drawersStore.openDrawer(ConnectAccountDrawer, { channel: channelTypeFromProvider[provider] as SocialChannelType })
    } else {
      handleConnectAccount(provider)
    }
  }

  return connectAccount
}
